import { Typography } from '@material-ui/core';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from '../../messages';
import useStyles from './styles';

interface Props {
  intl: IntlShape;
  policyNumber: string;
  subscriber: string;
}

const RenderOption = ({ policyNumber, subscriber, intl }: Props) => {
  const styles = useStyles();
  return (
    <div>
      <Typography className={styles.policyNumber}>
        {`${translate(messages.policyNumber, { intl })} : ${policyNumber}`}
      </Typography>
      <Typography className={styles.subscriber}>{subscriber}</Typography>
    </div>
  );
};

RenderOption.propTypes = {};

export default injectIntl(RenderOption);
